import type { Locale } from "@/lib/i18n";
import { pl, type CAdvertisementsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cAdvertisementsTranslations: Record<Locale, CAdvertisementsTranslations> = {
  pl,
  en,
  de,
};

export type { CAdvertisementsTranslations };
